import React, { useEffect, useRef } from 'react';
import { APP_TOKEN_KEY, VALID_GAME_ID } from '@root/constants';
import {
  ConnectionStatus,
  CustomBetPopup,
  GameInfoModal,
  GameLimitsModal,
  GameRulesModal,
  MenuPopup,
  MyBetsHistoryModal,
  RollRejectedModal,
  RunPausedModal,
  RunResultModal,
} from '@root/feature/modals';
import {
  ControlsBlock,
  GameFrame,
  Header,
  LoaderScreen,
  NotAuthorizedScreen,
  StartScreen,
} from '@root/feature/screens';
import {
  useBetNotifications,
  useChipValues,
  useGameSubscriptions,
  usePhaserSync,
  useRoundHistoryInit,
} from '@root/hooks';
import { useActions } from '@root/store/store';
import { InActiveOverlay } from '@shared/feature';
import { useAnalytics } from '@shared/hooks';
import { AnalyticsEvent } from '@shared/services/analytics';
import styles from './GameLayout.module.scss';

const GameLayout: React.FC = () => {
  const storedToken = localStorage.getItem(APP_TOKEN_KEY);
  const { trackPage } = useAnalytics();
  const actions = useActions();
  const gamePageOpenTrackedRef = useRef(false);

  useGameSubscriptions();
  usePhaserSync();
  useBetNotifications();
  useRoundHistoryInit();
  useChipValues();

  useEffect(() => {
    if (gamePageOpenTrackedRef.current) return;
    gamePageOpenTrackedRef.current = true;
    trackPage(AnalyticsEvent.GAME_PAGE_OPEN, { gameId: VALID_GAME_ID });
  }, [trackPage]);

  // Bring back the colour this player last chose.
  useEffect(() => {
    actions.loadPawnColour();
  }, [actions]);

  if (!storedToken) {
    return <NotAuthorizedScreen />;
  }

  return (
    <div className={styles.stage}>
      <GameFrame />
      <Header />
      <ControlsBlock />
      <StartScreen />
      <MenuPopup />
      <CustomBetPopup />
      <ConnectionStatus />
      <GameInfoModal />
      <GameLimitsModal />
      <MyBetsHistoryModal />
      <GameRulesModal />
      <RunResultModal />
      <RunPausedModal />
      <RollRejectedModal />
      <InActiveOverlay gameId={VALID_GAME_ID} />
      <LoaderScreen />
    </div>
  );
};

export default GameLayout;
